import { TeamMembersContainer } from "@/containers";

export const TeamMembersPage = () => {
  return <TeamMembersContainer />;
};
